const studentWorks = [
  {
    id: 1,
    title: '《無光》-奈菈Nyra',
    videoId: 'PD2qnlai40s',
    tag: 'AI 影片製作',
  },
  {
    id: 2,
    title: '《ONWARD》-奈菈Nyra',
    videoId: '5k3mpWlNgKA',
    tag: 'AI 影片製作',
  },
  {
    id: 3,
    title: '《Just Five More》-奈菈Nyra',
    videoId: 'nobE71ZyyGQ',
    tag: 'AI 影片製作',
  },
];

export default function StudentWorks() {

  return (
    <section id="student-works" className="relative py-32 px-8 bg-black overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-amber-950/10 to-black pointer-events-none" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[1px] bg-gradient-to-r from-transparent via-amber-500/30 to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-12 h-px bg-gradient-to-r from-transparent to-amber-400" />
            <span
              className="text-amber-400/80 text-xs tracking-[0.4em] font-light uppercase"
              style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
            >
              STUDENT SHOWCASE
            </span>
            <div className="w-12 h-px bg-gradient-to-l from-transparent to-amber-400" />
          </div>
          <h2
            className="text-5xl md:text-6xl font-black leading-tight tracking-tight mb-6"
            style={{ fontFamily: "'Noto Serif TC', serif" }}
          >
            <span
              style={{
                background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 30%, #fde68a 60%, #d97706 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                filter: 'drop-shadow(0 0 30px rgba(251,191,36,0.4))',
              }}
            >
              學員作品展示
            </span>
          </h2>
          <p
            className="text-white/50 text-base leading-relaxed max-w-xl mx-auto"
            style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
          >
            這是學員嶸photography製作的虛擬偶像<br />
            只要你願意，我們也可以從0基礎一步步帶你製作
          </p>
        </div>

        {/* Works Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {studentWorks.map((work, index) => (
            <div
              key={work.id}
              className="group relative rounded-sm overflow-hidden border border-amber-500/20 hover:border-amber-400/60 transition-all duration-500 hover:scale-[1.03] hover:shadow-2xl hover:shadow-amber-500/20"
            >
              {/* Auto-play iframe */}
              <div className="relative aspect-video overflow-hidden bg-black">
                <iframe
                  src={`https://www.youtube.com/embed/${work.videoId}?autoplay=1&mute=1&loop=1&playlist=${work.videoId}&controls=0&rel=0&modestbranding=1&playsinline=1`}
                  title={work.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                />
                {/* Number badge */}
                <div className="absolute top-4 left-4 pointer-events-none">
                  <span
                    className="text-amber-400/60 text-xs tracking-[0.3em]"
                    style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
                  >
                    {String(index + 1).padStart(2, '0')}
                  </span>
                </div>
              </div>

              {/* Info */}
              <div className="p-6 bg-gradient-to-b from-black/80 to-black">
                <h3
                  className="text-xl font-bold text-white mb-3"
                  style={{ fontFamily: "'Noto Serif TC', serif" }}
                >
                  {work.title}
                </h3>
                <div className="flex items-center justify-between">
                  <span
                    className="inline-block px-4 py-1.5 bg-amber-500/10 rounded-sm text-xs text-amber-400 border border-amber-500/30 tracking-widest"
                    style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
                  >
                    {work.tag}
                  </span>
                  <span
                    className="text-amber-400/50 text-xs flex items-center gap-1"
                    style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
                  >
                    <i className="ri-loop-left-line text-sm" />
                    自動循環
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
